import { render, staticRenderFns } from "./Created.vue?vue&type=template&id=5b228fd1&"
import script from "./Created.vue?vue&type=script&lang=ts&"
export * from "./Created.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports